import { tagSummary } from '@/mocks/home';
import SectionHeading from './SectionHeading';

const sizeStyles: Record<string, string> = {
  lg: 'text-base md:text-lg px-5 py-3 bg-primary-100 text-primary-800 border-primary-200',
  md: 'text-sm md:text-base px-4 py-2.5 bg-accent-100 text-accent-800 border-accent-200',
  sm: 'text-xs md:text-sm px-3.5 py-2 bg-secondary-100 text-secondary-900 border-secondary-200',
};

export default function TagSummary() {
  return (
    <section id="tags" className="w-full scroll-mt-24 bg-background-100 py-16 md:py-24 md:scroll-mt-28">
      <div className="mx-auto w-full max-w-shell px-4 md:px-8">
        <SectionHeading
          kicker="06 / TAGS"
          title="槽点汇总"
          desc="把散落在评论、帖子和私信里的抱怨归类，去重之后剩下的，就是下面这些被反复提到的词。字号越大，被提得越多。"
        />

        <div data-reveal className="mt-10 flex flex-wrap gap-3 md:mt-14 md:gap-4">
          {tagSummary.map((tag) => (
            <a
              key={tag.name}
              href="#ranking"
              className={`inline-flex items-center gap-2 rounded-full border transition-transform hover:-translate-y-0.5 cursor-pointer whitespace-nowrap ${
                sizeStyles[tag.size] ?? sizeStyles.sm
              }`}
            >
              {tag.name}
              <span className="text-xs opacity-70">{tag.count}</span>
            </a>
          ))}
        </div>

        <div data-reveal className="mt-12 grid grid-cols-1 gap-6 border-t border-background-300 pt-10 md:grid-cols-3 md:gap-8">
          <div>
            <p className="font-display text-4xl leading-none text-primary-500 md:text-5xl">38</p>
            <p className="mt-3 text-sm text-foreground-600">已归类槽点标签</p>
          </div>
          <div>
            <p className="font-display text-4xl leading-none text-accent-500 md:text-5xl">1,286</p>
            <p className="mt-3 text-sm text-foreground-600">收录档案条目</p>
          </div>
          <div>
            <p className="font-display text-4xl leading-none text-secondary-500 md:text-5xl">7</p>
            <p className="mt-3 text-sm text-foreground-600">持续更新的内容分区</p>
          </div>
        </div>
      </div>
    </section>
  );
}